import superadmin from "@/middleware/superadmin"
import onlySuperadmin from "@/middleware/onlySuperadmin"
import supermanager from "@/middleware/supermanager"
import superuser from "@/middleware/superuser"

import SuperAdminGeneral from "@/components/pages/superadmin/SuperAdminGeneral"
import superadmin_specialist from "@/middleware/superadmin_specialist"
import superadminAccountManager from "@/middleware/superadminAccountManager"


export default {
    path: '/superadmin',
    meta: {middleware: [superuser], layout: "super_admin", rights: []},
    // component: () => import('../components/pages/superadmin/SuperAdminGeneral.vue'),
    component: SuperAdminGeneral,
    children: [
        { path: '', redirect: '/superadmin/clinics' },
        {
            path: 'clinics', name: "SuperAdminClinics",
            meta: { middleware: [superuser], layout: "super_admin", rights: [] },
            component: () => import('@/components/pages/superadmin/clinics/SuperAdminClinics.vue')
        },
        {
            path: 'tariffs', name: "SuperAdminTariffs",
            meta: { middleware: [superadmin], layout: "super_admin", rights: [] },
            component: () => import('@/components/pages/superadmin/tariffs/SuperAdminTariffs.vue')
        },
        {
            path: 'payments',
            meta: { middleware: [superadminAccountManager], layout: "super_admin", rights: [] },
            component: () => import('@/components/pages/superadmin/payments/SuperAdminPaymentsGeneral.vue'),
            children: [
                { path: '', redirect: '/payments/list' },
                {
                    path: 'list', name: "SuperAdminPayments",
                    meta: { middleware: [superadminAccountManager], layout: "super_admin", rights: [] },
                    component: () => import('@/components/pages/superadmin/payments/SuperAdminPayments.vue')
                },
                {
                    path: 'methods', name: "SuperAdminPayMethods",
                    meta: { middleware: [superadmin], layout: "super_admin", rights: [] },
                    component: () => import('@/components/pages/superadmin/payments/SuperAdminPayMethods.vue')
                },
                {
                    path: 'rates', name: "SuperAdminBillingCurrencyRates",
                    meta: { middleware: [superadmin], layout: "super_admin", rights: [] },
                    // component: () => import('../components/pages/warehouse/Groups.vue')
                    component: () => import('@/components/pages/superadmin/payments/SuperAdminBillingCurrencyRates.vue')
                },
                {
                    path: 'services', name: "SuperAdminBillingServices",
                    meta: { middleware: [superadmin], layout: "super_admin", rights: [] },
                    component: () => import('@/components/pages/superadmin/payments/SuperAdminBillingServices.vue')

                },
                {
                    path: 'bonuses', name: "SuperAdminBonuses",
                    meta: { middleware: [superadmin], layout: "super_admin", rights: [] },
                    component: () => import('@/components/pages/superadmin/payments/SuperAdminBonuses.vue')
                },
                {
                    path: 'online_contract_payments', name: "SuperAdminOnlineContractPayments",
                    meta: { middleware: [superadminAccountManager], layout: "super_admin", rights: [] },
                    component: () => import('@/components/pages/superadmin/payments/SuperAdminOnlineContractPayments.vue')
                },
            ]
        },
        {
            path: 'notifications', name: "SuperAdminNotifications",
            meta: { middleware: [superadmin], layout: "super_admin", rights: [] },
            component: () => import('@/components/pages/superadmin/notifications/SuperAdminNotifications.vue')
        },
        {
            path: 'popups', name: "SuperAdminPopups",
            meta: { middleware: [superadmin], layout: "super_admin", rights: [] },
            component: () => import('@/components/pages/superadmin/notifications/SuperAdminPopups.vue')
        },
        {
            path: 'legal-documents', name: "SuperAdminLegalDocuments",
            meta: { middleware: [onlySuperadmin], layout: "super_admin", rights: [] },
            component: () => import('@/components/pages/superadmin/legal/SuperAdminLegalDocuments.vue')
        },
        {
            path: 'api', name: "SuperAdminAPI",
            meta: { middleware: [superadmin], layout: "super_admin", rights: [] },
            component: () => import('@/components/pages/superadmin/api/SuperAdminAPI.vue')
        },
        {
            path: 'users', name: "SuperAdminUsers",
            meta: { middleware: [onlySuperadmin], layout: "super_admin", rights: [] },
            component: () => import('@/components/pages/superadmin/users/SuperAdminUsers.vue')
        },
        {
            path: 'dictionaries',
            meta: { middleware: [superadmin], layout: "super_admin", rights: [] },
            component: () => import('@/components/pages/superadmin/dictionaries/SuperAdminDictionariesGeneral.vue'),
            children: [
                { path: '', redirect: '/countries' },
                {
                    path: 'countries', name: "SuperAdminCountries",
                    meta: { middleware: [onlySuperadmin], layout: "super_admin", rights: [] },
                    component: () => import('@/components/pages/superadmin/dictionaries/SuperAdminCountries.vue')
                },
                {
                    path: 'cities', name: "SuperAdminCities",
                    meta: { middleware: [onlySuperadmin], layout: "super_admin", rights: [] },
                    component: () => import('@/components/pages/superadmin/dictionaries/SuperAdminCities.vue')
                },
                {
                    path: 'sources', name: "SuperAdminSources",
                    meta: { middleware: [onlySuperadmin], layout: "super_admin", rights: [] },
                    component: () => import('@/components/pages/superadmin/dictionaries/SuperAdminSources.vue')
                },
            ]
        },
        {
            path: 'logs',
            meta: {middleware: [superadmin], layout: "super_admin", rights: []},
            component: () => import('@/components/pages/superadmin/logs/SuperAdminLogsGeneral.vue'),
            children: [
                { path: '', redirect: '/auth' },
                {
                    path: 'auth', name: "SuperAdminAuthLogs",
                    meta: { middleware: [onlySuperadmin], layout: "super_admin", rights: [] },
                    component: () => import('../components/pages/superadmin/logs/SuperAdminLoginLogs.vue')
                },
                // {
                //     path: 'tariff', name: "SuperAdminTariffLogs",
                //     meta: { middleware: [onlySuperadmin], layout: "super_admin", rights: [] },
                //     component: () => import('../components/pages/superadmin/logs/SuperAdminTariffLogs.vue')
                // },
            ]
        },
        // {
        //     path: 'login_logs', name: 'SuperAdminLoginLogs',
        //     meta: { middleware: [onlySuperadmin], layout: "super_admin", rights: [] },
        //     component: () => import('../components/pages/superadmin/clinics/SuperAdminLoginLogs.vue')
        // },
        {
            path: 'developer', name: "SuperAdminDeveloper",
            meta: { middleware: [onlySuperadmin], layout: "super_admin", rights: [] },
            component: () => import('../components/pages/superadmin/SuperAdminDeveloper.vue')
        },
        {
            path: 'translator', name: "SuperAdminTranslator",
            meta: { middleware: [onlySuperadmin], layout: "super_admin", rights: [] },
            component: () => import('../components/pages/superadmin/SuperAdminTranslator.vue')
        },
        {
            path: 'clinic/manager/:id', name: "SuperAdminManagerClinic",
            meta: { middleware: [supermanager], layout: "super_admin", rights: [] },
            component: () => import('@/components/pages/superadmin/clinics/manager/SuperAdminManagerClinic.vue'),
            children: [
                { path: '', redirect: '/general' },
                {
                    path: 'general', name: "SuperAdminClinicGeneralManager",
                    meta: { middleware: [supermanager], layout: "super_admin", rights: [] },
                    component: () => import('@/components/pages/superadmin/clinics/manager/SuperAdminClinicGeneralManager.vue')
                },
                {
                    path: 'tariff', name: "SuperAdminClinicTariffManager",
                    meta: { middleware: [supermanager], layout: "super_admin", rights: [] },
                    component: () => import('@/components/pages/superadmin/clinics/manager/SuperAdminClinicTariffManager.vue')
                },
                {
                    path: 'rights', name: "SuperAdminClinicRightsManager",
                    meta: { middleware: [supermanager], layout: "super_admin", rights: [] },
                    component: () => import('@/components/pages/superadmin/clinics/manager/SuperAdminClinicRightsManager.vue')
                },
                {
                    path: 'supermanagers', name: "SuperAdminClinicSuperManagersManager",
                    meta: { middleware: [supermanager], layout: "super_admin", rights: [] },
                    component: () => import('@/components/pages/superadmin/clinics/manager/SuperAdminClinicSuperManagersManager.vue')
                },
            ]
        },
        {
            path: 'clinic/:id',
            meta: { middleware: [superadmin_specialist], layout: "default", rights: [] },
            // component: () => import('../components/pages/superadmin/clinics/SuperAdminClinicPage.vue'),
            component: () => import('@/components/pages/superadmin/clinics/SuperAdminClinicPage.vue'),
            children: [
                // { path: '', redirect: '/clinic/:id/general' },
                { path: '', redirect: to => ({ name: 'SuperAdminClinicGeneral', params: { id: to.params.id } }) },
                {
                    path: 'general', name: "SuperAdminClinicGeneral",
                    meta: { middleware: [superadmin_specialist], layout: "super_admin", rights: [] },
                    // component: () => import('../components/pages/superadmin/clinics/SuperAdminClinicGeneral.vue')
                    component: () => import('@/components/pages/superadmin/clinics/SuperAdminClinicGeneral.vue')
                },
                {
                    path: 'rights', name: "SuperAdminClinicRights",
                    meta: { middleware: [superadmin_specialist], layout: "super_admin", rights: [] },
                    // component: () => import('../components/pages/superadmin/clinics/SuperAdminClinicRights.vue')
                    component: () => import('@/components/pages/superadmin/clinics/SuperAdminClinicRights.vue')
                },
                {
                    path: 'services', name: "SuperAdminClinicServices",
                    meta: { middleware: [superadmin_specialist], layout: "super_admin", rights: [] },
                    // component: () => import('../components/pages/superadmin/clinics/SuperAdminClinicServices.vue')
                    component: () => import('@/components/pages/superadmin/clinics/SuperAdminClinicServices.vue')
                },
                {
                    path: 'categories', name: "SuperAdminClinicCategories",
                    meta: { middleware: [superadmin_specialist], layout: "super_admin", rights: [] },
                    component: () => import('@/components/pages/superadmin/clinics/SuperAdminClinicCategories.vue')
                },
                {
                    path: 'managers', name: "SuperAdminClinicManagers",
                    meta: { middleware: [superadmin_specialist], layout: "super_admin", rights: [] },
                    component: () => import('@/components/pages/superadmin/clinics/SuperAdminClinicManagers.vue')
                },
                {
                    path: 'supermanagers', name: "SuperAdminClinicSuperManagers",
                    meta: { middleware: [superadmin_specialist], layout: "super_admin", rights: [] },
                    component: () => import('@/components/pages/superadmin/clinics/SuperAdminClinicSuperManagers.vue')
                },
                {
                    path: 'doctors', name: "SuperAdminClinicDoctors",
                    meta: { middleware: [superadmin_specialist], layout: "super_admin", rights: [] },
                    component: () => import('@/components/pages/superadmin/clinics/SuperAdminClinicDoctors.vue')
                },
                {
                    path: 'assistants', name: "SuperAdminClinicAssistants",
                    meta: { middleware: [superadmin_specialist], layout: "super_admin", rights: [] },
                    component: () => import('@/components/pages/superadmin/clinics/SuperAdminClinicAssistants.vue')
                },
                {
                    path: 'technics', name: "SuperAdminClinicTechnics",
                    meta: { middleware: [superadmin_specialist], layout: "super_admin", rights: [] },
                    component: () => import('@/components/pages/superadmin/clinics/SuperAdminClinicTechnics.vue')
                },
                {
                    path: 'curators', name: "SuperAdminClinicCurators",
                    meta: { middleware: [superadmin_specialist], layout: "super_admin", rights: [] },
                    component: () => import('@/components/pages/superadmin/clinics/SuperAdminClinicCurators.vue')
                },
                {
                    path: 'patients', name: "SuperAdminClinicPatients",
                    meta: { middleware: [superadmin], layout: "super_admin", rights: [] },
                    component: () => import('@/components/pages/superadmin/clinics/SuperAdminClinicPatients.vue'),
                },
                {
                    path: 'patients/:patientId/notifications',
                    name: "SuperAdminPatientNotifications",
                    meta: { middleware: [superadmin], layout: "super_admin", rights: [] },
                    component: () => import('@/components/pages/superadmin/clinics/patients/SuperAdminPatientNotifications.vue'),
                },
                {
                    path: 'tariffs', name: "SuperAdminClinicTariffs",
                    meta: { middleware: [superadmin_specialist], layout: "super_admin", rights: [] },
                    component: () => import('@/components/pages/superadmin/clinics/SuperAdminClinicTariffs.vue')
                },
                {
                    path: 'branches', name: "SuperAdminClinicBranches",
                    meta: { middleware: [superadmin_specialist], layout: "super_admin", rights: [] },
                    component: () => import('@/components/pages/superadmin/clinics/SuperAdminClinicBranches.vue')
                },
                {
                    path: 'patients_import', name: "SuperAdminClinicImport",
                    meta: { middleware: [superadmin_specialist], layout: "super_admin", rights: [] },
                    component: () => import('@/components/pages/superadmin/clinics/SuperAdminClinicImport.vue')
                },
                {
                    path: 'services_import', name: "SuperAdminClinicServicesImport",
                    meta: { middleware: [superadmin_specialist], layout: "super_admin", rights: [] },
                    component: () => import('@/components/pages/superadmin/clinics/SuperAdminClinicServicesImport.vue')
                },
                {
                    path: 'integrations', name: "SuperAdminClinicIntegrations",
                    meta: { middleware: [superadmin_specialist], layout: "super_admin", rights: [] },
                    component: () => import('@/components/pages/superadmin/clinics/SuperAdminClinicIntegrations.vue')
                },
                {
                    path: 'egisz', name: "SuperAdminClinicEGISZ",
                    meta: { middleware: [superadmin_specialist], layout: "super_admin", rights: [] },
                    component: () => import('@/components/pages/superadmin/clinics/SuperAdminClinicEGISZ.vue')
                },
                {
                    path: 'prices', name: "SuperAdminClinicPrices",
                    meta: { middleware: [superadmin_specialist], layout: "super_admin", rights: [] },
                    component: () => import('@/components/pages/superadmin/clinics/SuperAdminClinicPrices.vue')
                },
                {
                    path: 'marketing_notifications', name: "SuperAdminClinicMarketingNotifications",
                    meta: { middleware: [superadmin_specialist], layout: "super_admin", rights: [] },
                    component: () => import('@/components/pages/superadmin/clinics/SuperAdminClinicMarketingNotifications.vue')
                },
                {
                    path: 'logs', name: "SuperAdminClinicLogs",
                    meta: { middleware: [superadmin_specialist], layout: "super_admin", rights: [] },
                    component: () => import('@/components/pages/superadmin/clinics/SuperAdminClinicLogs.vue')
                },
                {
                    path: 'tariff_logs', name: "SuperAdminTariffLogs",
                    meta: { middleware: [superadmin_specialist], layout: "super_admin", rights: [] },
                    component: () => import('../components/pages/superadmin/logs/SuperAdminTariffLogs.vue')
                },
                {
                    path: 'agreements', name: "SuperAdminClinicAgreementTemplates",
                    meta: { middleware: [superadmin_specialist], layout: "super_admin", rights: [] },
                    component: () => import('../components/pages/superadmin/clinics/SuperAdminClinicAgreementTemplates.vue')
                },
                {
                    path: 'contracts', name: "SuperAdminClinicContractTemplates",
                    meta: { middleware: [superadmin_specialist], layout: "super_admin", rights: [] },
                    component: () => import('../components/pages/superadmin/clinics/SuperAdminClinicContractTemplates.vue')
                },
                {
                    path: 'api', name: "SuperAdminClinicAPI",
                    meta: { middleware: [superadmin_specialist], layout: "super_admin", rights: [] },
                    component: () => import('../components/pages/superadmin/clinics/SuperAdminClinicAPI.vue')
                },
            ]
        },
        {
            path: 'templates',
            meta: { middleware: [superadmin_specialist], layout: "super_admin", rights: [] },
            component: () => import('@/components/pages/superadmin/templates/SuperAdminTemplatesGeneral.vue'),
            children: [
                { path: '', redirect: '/treatment' },
                {
                    path: 'treatment', name: "SuperAdminTreatmentTemplates",
                    meta: { middleware: [superadmin_specialist], layout: "super_admin", rights: [] },
                    component: () => import('../components/pages/superadmin/templates/SuperAdminTreatmentTemplates.vue')
                },
                {
                    path: 'agreements', name: "SuperAdminAgreementTemplates",
                    meta: { middleware: [superadmin_specialist], layout: "super_admin", rights: [] },
                    component: () => import('../components/pages/superadmin/templates/SuperAdminAgreementTemplates.vue')
                },
                {
                    path: 'agreement_categories', name: "SuperAdminAgreementTemplateCategories",
                    meta: { middleware: [superadmin_specialist], layout: "super_admin", rights: [] },
                    component: () => import('../components/pages/superadmin/templates/SuperAdminAgreementTemplateCategories.vue')
                },
                {
                    path: 'contracts', name: "SuperAdminContractTemplates",
                    meta: { middleware: [superadmin_specialist], layout: "super_admin", rights: [] },
                    component: () => import('../components/pages/superadmin/templates/SuperAdminContractTemplates.vue')
                },
                {
                    path: 'diagnosis', name: "SuperAdminDiagnosesTemplates",
                    meta: { middleware: [superadmin_specialist], layout: "super_admin", rights: [] },
                    component: () => import('../components/pages/superadmin/templates/SuperAdminDiagnosesTemplates.vue')
                },
            ]
        },
        {
            path: 'market',
            meta: { middleware: [onlySuperadmin], layout: "super_admin", rights: [] },
            component: () => import('@/components/pages/superadmin/market/SuperAdminMarketGeneral.vue'),
            children: [
                { path: '', redirect: '/superadmin/market/cards' },
                {
                    path: 'categories', name: "SuperAdminMarketCategories",
                    meta: { middleware: [onlySuperadmin], layout: "super_admin", rights: [] },
                    component: () => import('../components/pages/superadmin/market/SuperAdminMarketCategories.vue')
                },
                {
                    path: 'cards', name: "SuperAdminMarketCards",
                    meta: { middleware: [onlySuperadmin], layout: "super_admin", rights: [] },
                    component: () => import('../components/pages/superadmin/market/SuperAdminMarketCards.vue')
                },
            ]
        }
    ]
}
